module.exports = __webpack_public_path__ + "img/lichtgestalten2.3dc49378.png";